import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TimingOption } from "../../reports-service/reports.model";

@Component({
  selector: 'app-rpt-timing-options',
  templateUrl: './rpt-timing-options.component.html',
  styleUrls: ['./rpt-timing-options.component.scss']
})

export class RptTimingOptionsComponent implements OnInit, OnChanges {
  @Input() timingOptions: TimingOption[];
  @Output() onSetTimingOption = new EventEmitter<TimingOption>();
  @ViewChild('timingDropdown') timingDropdown: NgbDropdown;

  selectedTiming: string;
  selectedTimingOption: TimingOption;

  ngOnInit() {
    if (this.timingOptions && this.timingOptions.length > 0)
    {
      this.setDefaultTiming();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.timingOptions && this.timingOptions && this.timingOptions.length > 0 && !this.selectedTimingOption)
    {
      this.setDefaultTiming();
    }
  }

  private setDefaultTiming(): void {
    this.selectedTimingOption = this.timingOptions[0];
    this.selectedTiming = this.timingOptions[0].days;
    this.onSetTimingOption.emit(this.selectedTimingOption);
  }

  getSelectedTimingName(): string {
    const selected = this.timingOptions.find(t => t.days === this.selectedTiming);
    return selected.name;
  }

  timingOnClick(timingOption: TimingOption): void {
    this.selectedTimingOption = timingOption;
    this.selectedTiming = timingOption.days;
    this.onSetTimingOption.emit(this.selectedTimingOption);

    if (this.timingDropdown)
    {
      this.timingDropdown.close();
    }
  }
}
